export default {"src":"/_next/static/media/radioIcon.d567f2f1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};